import { Component } from '@angular/core';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-developer-status',
  templateUrl: './developer-status.component.html',
  styleUrls: ['./developer-status.component.scss']
})
export class DeveloperStatusComponent {


  public dev_evn = environment;

}
